import { Icon, Paragraph } from "@sicredi/react";
import styles from "./styles.module.scss";
import { handleGoAppStore } from "#/contextProver/ContextProverServices";
import { ButtonLinkChevronRight } from "#/components/ButtonLinkChevronRight";

export const AppAlertTracking: React.FC = () => {
  return (
    <div className={styles.alert_app_container}>
      <Icon name="smartphone" className={styles.margin_app} />

      <Paragraph size="small" weight="normal" className={styles.margin_app}>
        Acesse o aplicativo <strong>Consórcio do Sicredi</strong>. Nele você
        poderá:
      </Paragraph>
      <br />
      <div className={styles.container_li}>
        <li>Ofertar lances</li>
        <li>Conferir extrato detalhado do(s) pagamento(s)</li>
        <li>Ver calendário e resultado das assembleias</li>
        <li>Conferir informe de rendimentos</li>
      </div>

      <div className={styles.button_link_app}>
        <ButtonLinkChevronRight
          text="Acessar app do Consórcio"
          onClick={handleGoAppStore}
        />
      </div>
    </div>
  );
};
